import { useTheme } from "@mui/material";

export const useIsFormV2 = () => {
  const theme = useTheme();

  return theme.constants.isFormV2;
};
